/* ================================================================
   MO — EN-TÊTE DE COLLECTION : BOUTONS PAR CLUB (01/10)

   Va avec sections/mo-collection-tete.liquid et
   templates/collection.mo.liquid.

   1. Charge toute la collection en JSON (?view=mo, 250 par page, avec
      les filtres et le tri en cours), en arrière-plan.
   2. Lit le club dans chaque carte (première ligne de la carte, coupée
      par le snippet mo-carte) et compte les maillots par club.
   3. Remplit la rangée de boutons : « Tous » + un bouton par club,
      du plus fourni au moins fourni. S'il n'y a qu'un club, les
      boutons trient par version (Domicile, Extérieur, Third…).
   4. Un toucher sur un club : la grille de Dawn est mise de côté (pas
      supprimée) et une grille avec les seuls maillots de ce club la
      remplace. « Tous » remet la grille de Dawn et ses pages.
   5. Remplit aussi les chiffres de l'affiche : nombre d'équipes et
      prix le plus bas.

   Si les filtres de Dawn changent la grille, on revient sur « Tous »
   et on recompte avec les nouveaux filtres.
   Si le chargement échoue : la rangée disparaît, la page reste celle
   de Dawn.
   ================================================================ */
(function () {
  'use strict';

  if (window.__moCollection) return;
  window.__moCollection = true;

  /* couleurs des pastilles : [couleur 1, couleur 2] ; club absent = pas de pastille */
  var COULEURS = {
    'PSG': ['#004170', '#DA291C'], 'PARIS FC': ['#1B2A5C', '#8FD3F5'], 'MARSEILLE': ['#FFFFFF', '#2FAEE0'],
    'LYON': ['#FFFFFF', '#DA0812'], 'LENS': ['#FFE000', '#E30613'], 'RC LENS': ['#FFE000', '#E30613'],
    'LILLE': ['#E01E13', '#1B2A5C'], 'MONACO': ['#E30613', '#FFFFFF'], 'NICE': ['#C8102E', '#111111'],
    'STRASBOURG': ['#0072C6', '#FFFFFF'], 'REAL MADRID': ['#FFFFFF', '#FEBE10'], 'FC BARCELONE': ['#A50044', '#004D98'],
    'BARCELONE': ['#A50044', '#004D98'], 'ATLÉTICO MADRID': ['#CB3524', '#FFFFFF'], 'ATLETICO MADRID': ['#CB3524', '#FFFFFF'],
    'MALAGA': ['#3A7CC0', '#FFFFFF'], 'BAYERN MUNICH': ['#DC052D', '#FFFFFF'], 'DORTMUND': ['#FDE100', '#111111'],
    'LEIPZIG': ['#FFFFFF', '#DD0741'], 'JUVENTUS': ['#111111', '#FFFFFF'], 'AC MILAN': ['#FB090B', '#111111'],
    'MILAN': ['#FB090B', '#111111'], 'INTER MILAN': ['#010E80', '#111111'], 'INTER': ['#010E80', '#111111'],
    'NAPLES': ['#12A0D7', '#FFFFFF'], 'AS ROMA': ['#8E1F2F', '#F0BC42'], 'ARSENAL': ['#EF0107', '#FFFFFF'],
    'CHELSEA': ['#034694', '#FFFFFF'], 'LIVERPOOL': ['#C8102E', '#F6EB61'], 'MANCHESTER CITY': ['#6CABDD', '#FFFFFF'],
    'MANCHESTER UNITED': ['#DA291C', '#FBE122'], 'TOTTENHAM': ['#FFFFFF', '#132257'], 'NEWCASTLE': ['#111111', '#FFFFFF'],
    'ASTON VILLA': ['#670E36', '#95BFE5'], 'EVERTON': ['#003399', '#FFFFFF'], 'BRIGHTON': ['#0057B8', '#FFFFFF'],
    'LEICESTER': ['#003090', '#FDBE11'], 'BENFICA': ['#E30613', '#FFFFFF'], 'PORTO': ['#00428C', '#FFFFFF'],
    'SPORTING': ['#008057', '#FFFFFF'], 'AJAX': ['#FFFFFF', '#D2122E'], 'CELTIC': ['#018749', '#FFFFFF'],
    'BOCA JUNIORS': ['#103F79', '#F3B229'], 'RIVER PLATE': ['#FFFFFF', '#E30613'], 'FLAMENGO': ['#C52613', '#111111'],
    'FLUMINENSE': ['#7A1E3A', '#00613C'], 'SANTOS': ['#FFFFFF', '#111111'], 'CORINTHIANS': ['#FFFFFF', '#111111'],
    'INTER MIAMI': ['#F7B5CD', '#231F20'], 'AL-NASSR': ['#FFDD00', '#1D3E8A'], 'AL NASSR': ['#FFDD00', '#1D3E8A'],
    'AL-HILAL': ['#0055A5', '#FFFFFF'], 'AL HILAL': ['#0055A5', '#FFFFFF'],
    'FRANCE': ['#002654', '#ED2939'], 'BRÉSIL': ['#FFDF00', '#009C3B'], 'BRESIL': ['#FFDF00', '#009C3B'],
    'PORTUGAL': ['#DA291C', '#046A38'], 'ARGENTINE': ['#75AADB', '#FFFFFF'], 'ESPAGNE': ['#C60B1E', '#FFC400'],
    'ALLEMAGNE': ['#FFFFFF', '#111111'], 'ITALIE': ['#0066CC', '#FFFFFF'], 'ANGLETERRE': ['#FFFFFF', '#CF081F'],
    'ALGÉRIE': ['#FFFFFF', '#006233'], 'ALGERIE': ['#FFFFFF', '#006233'], 'MAROC': ['#C1272D', '#006233'],
    'SÉNÉGAL': ['#00853F', '#FDEF42'], 'SENEGAL': ['#00853F', '#FDEF42'], 'JAPON': ['#000555', '#FFFFFF'],
    'BELGIQUE': ['#E30613', '#111111'], 'PAYS-BAS': ['#FF6200', '#FFFFFF'], 'PAYS BAS': ['#FF6200', '#FFFFFF'],
    'MEXIQUE': ['#006847', '#CE1126'], "CÔTE D'IVOIRE": ['#FF8200', '#009A44'], 'NIGERIA': ['#008751', '#FFFFFF'],
    'PALESTINE': ['#111111', '#007A3D'], 'COLOMBIE': ['#FCD116', '#003893'], 'URUGUAY': ['#5CBFEB', '#FFFFFF'],
    'CROATIE': ['#FF0000', '#FFFFFF'], 'MALI': ['#14B53A', '#FCD116'], 'CANADA': ['#FF0000', '#FFFFFF'],
    'NORVÈGE': ['#BA0C2F', '#00205B'], 'NORVEGE': ['#BA0C2F', '#00205B'], 'CORÉE DU SUD': ['#FFFFFF', '#CD2E3A'],
    'ÉQUATEUR': ['#FFDD00', '#034EA2'], 'COSTA RICA': ['#002B7F', '#CE1126'], 'CHIVAS GUADALAJARA': ['#E30613', '#FFFFFF']
  };

  /* versions (mode « un seul club ») : libellé + mots du titre qui l'annoncent */
  var VERSIONS = [
    ['Domicile', ['DOMICILE', 'HOME']],
    ['Extérieur', ['EXTÉRIEUR', 'EXTERIEUR', 'AWAY']],
    ['Third', ['THIRD', 'THRID']],
    ['Fourth', ['FOURTH']],
    ['Rétro', ['RETRO', 'RÉTRO', 'VINTAGE']],
    ['Concept', ['CONCEPT']],
    ['Édition spéciale', ['SPECIAL', 'SPÉCIAL', 'EDITION', 'ÉDITION', 'BACK2BACK', 'NIGHT']],
    ['Manches longues', ['MANCHES']],
    ['Player', ['PLAYER']],
    ['Enfant', ['ENFANT', 'ENFANTS', 'KIDS']],
    ['Gardien', ['GARDIEN']],
    ['Entraînement', ['ENTRAINEMENT', 'ENTRAÎNEMENT', 'ENTRAINMENT', 'TRAINING']]
  ];

  var MAX_CLUBS = 24;   /* au-delà : un bouton « Autres » */
  var MAX_PAGES = 4;    /* 4 x 250 produits */

  var tete, rang, grille, mot;
  var produits = [];       /* {h, club, versions[], p, pt} */
  var mode = 'club';
  var actif = '*';
  var groupes = [];        /* [{cle, label, n}] */
  var autres = {};         /* clubs rangés dans « Autres » */
  var compteurs = null;    /* textes d'origine de Dawn (« 15 produits ») */
  var chargement = 0;

  function $(s, r) { return (r || document).querySelector(s); }

  /* ---------- texte ---------- */
  var PETITS = { DE: 1, DU: 1, DES: 1, LA: 1, LE: 1, LES: 1, ET: 1, Y: 1 };
  function joli(nom) {
    return nom.split(/\s+/).map(function (w, i) {
      if (i > 0 && PETITS[w]) return w.toLowerCase();
      if (w.length <= 3 && w === w.toUpperCase() && /[A-Z]/.test(w)) return w; /* PSG, AC, FC, USA */
      var l = w.toLowerCase().replace(/(^|[-'’])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); });
      /* CÔTE D'IVOIRE -> Côte d'Ivoire */
      if (i > 0 && /^[DL]['’]/.test(l)) l = l.charAt(0).toLowerCase() + l.slice(1);
      return l;
    }).join(' ');
  }
  function echap(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function versionsDe(titre) {
    var T = ' ' + titre.toUpperCase().replace(/[\/,—–]/g, ' ') + ' ';
    var r = [];
    VERSIONS.forEach(function (v) {
      for (var i = 0; i < v[1].length; i++) {
        if (T.indexOf(' ' + v[1][i] + ' ') > -1) { r.push(v[0]); break; }
      }
    });
    return r;
  }

  /* ---------- données ---------- */
  function urlDonnees(page) {
    var u = new URL(tete.getAttribute('data-url'), location.origin);
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k !== 'page' && k !== 'view' && k !== 'section_id') u.searchParams.append(k, v);
    });
    u.searchParams.set('view', 'mo');
    u.searchParams.set('page', page);
    return u.pathname + u.search;
  }

  /* 01/10 : le cache ne garde que la collection affichée. Avant, chaque
     collection visitée restait en mémoire (4,5 Mo après quelques pages)
     et le stockage de session pouvait se remplir : les autres réglages ne
     s'enregistraient alors plus (ex. la fermeture du pop-up « Commande »). */
  function garderSeulement(chemin) {
    try {
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf('moct:') === 0 && k.slice(5).split('?')[0] !== chemin) sessionStorage.removeItem(k);
      }
    } catch (e) {}
  }

  function lire(url) {
    try {
      var c = sessionStorage.getItem('moct:' + url);
      if (c) {
        var o = JSON.parse(c);
        if (Date.now() - o.t < 10 * 60 * 1000) return Promise.resolve(o.d);
      }
    } catch (e) {}
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (txt) {
        var d = JSON.parse(txt);
        garderSeulement(url.split('?')[0]);
        try { sessionStorage.setItem('moct:' + url, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      });
  }

  function charger() {
    var tour = ++chargement;
    return lire(urlDonnees(1)).then(function (d1) {
      var pages = Math.min(d1.pages || 1, MAX_PAGES);
      var suite = [];
      for (var p = 2; p <= pages; p++) suite.push(lire(urlDonnees(p)));
      return Promise.all(suite).then(function (autresPages) {
        return [d1].concat(autresPages);
      });
    }).then(function (lots) {
      if (tour !== chargement) return;
      var tpl = document.createElement('template');
      produits = [];
      lots.forEach(function (d) {
        (d.produits || []).forEach(function (x) {
          tpl.innerHTML = x.h;
          var c = tpl.content.querySelector('.moc__club');
          produits.push({
            h: x.h,
            club: (c ? c.textContent : x.t).replace(/\s+/g, ' ').trim().toUpperCase(),
            versions: versionsDe(x.t),
            p: x.p,
            pt: x.pt
          });
        });
      });
      construire();
    }).catch(function () {
      if (tour !== chargement) return;
      rang.hidden = true;
    });
  }

  /* ---------- rangée de boutons ---------- */
  function construire() {
    actif = '*';
    autres = {};
    var parClub = {};
    produits.forEach(function (x) { parClub[x.club] = (parClub[x.club] || 0) + 1; });
    var clubs = Object.keys(parClub).sort(function (a, b) {
      return parClub[b] - parClub[a] || a.localeCompare(b, 'fr');
    });

    groupes = [];
    if (clubs.length >= 2) {
      mode = 'club';
      clubs.forEach(function (c, i) {
        if (clubs.length > MAX_CLUBS && i >= MAX_CLUBS - 1) { autres[c] = 1; return; }
        groupes.push({ cle: c, label: joli(c), n: parClub[c] });
      });
      var nAutres = Object.keys(autres).reduce(function (s, c) { return s + parClub[c]; }, 0);
      if (nAutres) groupes.push({ cle: '+', label: 'Autres', n: nAutres });
    } else {
      mode = 'version';
      VERSIONS.forEach(function (v) {
        var n = produits.filter(function (x) { return x.versions.indexOf(v[0]) > -1; }).length;
        if (n && n < produits.length) groupes.push({ cle: v[0], label: v[0], n: n });
      });
    }

    chiffres(clubs.length);

    if (!produits.length || groupes.length < (mode === 'club' ? 2 : 1)) {
      rang.hidden = true;
      return;
    }
    rang.setAttribute('aria-label', mode === 'club' ? 'Choisir une équipe' : 'Choisir une version');
    dessiner();
    rang.hidden = false;
    rang.classList.add('moct-puces--pret');
  }

  function dessiner() {
    var h = '<button type="button" class="moct-puce" data-v="*" aria-pressed="' + (actif === '*') + '">Tous <small>' + produits.length + '</small></button>';
    groupes.forEach(function (g) {
      var c = mode === 'club' ? COULEURS[g.cle] : null;
      var rond = c ? '<span class="moct-rond" aria-hidden="true" style="--c1:' + c[0] + ';--c2:' + c[1] + '"></span>' : '';
      h += '<button type="button" class="moct-puce" data-v="' + echap(g.cle) + '" aria-pressed="' + (actif === g.cle) + '">'
        + rond + echap(g.label) + ' <small>' + g.n + '</small></button>';
    });
    rang.innerHTML = h;
  }

  function chiffres(nClubs) {
    var eq = $('[data-moct-equipes]', tete), px = $('[data-moct-prix]', tete);
    if (eq) {
      if (mode === 'club' && nClubs >= 2) {
        $('b', eq).textContent = nClubs;
        eq.lastElementChild.textContent = 'équipes';
        eq.hidden = false;
      } else if (mode === 'version' && groupes.length >= 2) {
        $('b', eq).textContent = groupes.length;
        eq.lastElementChild.textContent = 'versions';
        eq.hidden = false;
      } else {
        eq.hidden = true;
      }
    }
    if (px && produits.length) {
      var min = produits.reduce(function (a, x) { return x.p < a.p ? x : a; });
      $('b', px).textContent = min.pt;
      px.hidden = false;
    }
  }

  /* ---------- filtrer la grille ---------- */
  function garde(x) {
    if (actif === '*') return true;
    if (mode === 'club') return actif === '+' ? !!autres[x.club] : x.club === actif;
    return x.versions.indexOf(actif) > -1;
  }

  function compteur(texte) {
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (texte === null) {
        if (compteurs && compteurs[id] != null) el.textContent = compteurs[id];
      } else {
        compteurs = compteurs || {};
        if (compteurs[id] == null) compteurs[id] = el.textContent;
        el.textContent = texte;
      }
    });
    if (texte === null) compteurs = null;
  }

  function choisir(v) {
    actif = v;
    rang.querySelectorAll('.moct-puce').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === v));
    });

    var ul = document.getElementById('product-grid');
    var pag = grille.querySelector('.pagination-wrapper');
    var liste = grille.querySelector('[data-moct-liste]');

    if (v === '*') {
      if (liste) liste.remove();
      if (ul) ul.style.display = '';
      if (pag) pag.style.display = '';
      compteur(null);
    } else if (ul) {
      var sel = produits.filter(garde);
      if (!liste) {
        liste = document.createElement('ul');
        liste.setAttribute('data-moct-liste', '');
        liste.className = ul.className;
        liste.setAttribute('role', 'list');
        ul.parentNode.insertBefore(liste, ul.nextSibling);
      }
      liste.innerHTML = sel.map(function (x) { return '<li class="grid__item">' + x.h + '</li>'; }).join('');
      ul.style.display = 'none';
      if (pag) pag.style.display = 'none';
      var unite = (tete.getAttribute('data-mot') || 'maillots').replace(/s$/, '');
      compteur(sel.length + ' ' + unite + (sel.length > 1 ? 's' : ''));
    }

    /* le bouton choisi reste visible dans la rangée */
    var on = rang.querySelector('[aria-pressed="true"]');
    if (on) {
      var g = on.offsetLeft - 16, d = on.offsetLeft + on.offsetWidth - rang.clientWidth + 16;
      if (rang.scrollLeft > g) rang.scrollLeft = g;
      else if (rang.scrollLeft < d) rang.scrollLeft = d;
    }

    /* si on était descendu dans la grille, on remonte à son début */
    var haut = rang.getBoundingClientRect().top;
    var debut = grille.getBoundingClientRect().top - rang.offsetHeight - haut;
    if (debut < 0) window.scrollBy({ top: debut, behavior: 'smooth' });
  }

  /* ---------- démarrage ---------- */
  function demarrer() {
    tete = $('[data-moct]');
    if (!tete) return;
    rang = $('[data-moct-puces]', tete);
    grille = document.getElementById('ProductGridContainer');
    if (!rang) return;
    if (!grille || !document.getElementById('product-grid') || !window.fetch || !window.URLSearchParams) {
      rang.hidden = true;
      return;
    }

    /* la rangée passe juste au-dessus des filtres de Dawn, dans la
       section de la grille : elle peut ainsi rester collée en haut
       pendant tout le défilement de la grille */
    var filtres = document.getElementById('main-collection-filters');
    var avant = filtres || grille;
    avant.parentNode.insertBefore(rang, avant);
    mot = tete.getAttribute('data-mot');

    rang.addEventListener('click', function (e) {
      var b = e.target.closest('.moct-puce[data-v]');
      if (b) choisir(b.getAttribute('data-v'));
    });

    /* les filtres de Dawn remplacent le contenu de la grille : on
       revient sur « Tous » et on recompte avec les nouveaux filtres */
    var attente;
    new MutationObserver(function () {
      clearTimeout(attente);
      attente = setTimeout(function () {
        compteurs = null;
        charger();
      }, 250);
    }).observe(grille, { childList: true });

    charger();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
